global.jQuery = global.$ = window.jQuery = require('jquery');

require('jquery.easing');
require('jquery.color');
require('jquery.inview');
require('jquery.matchHeight');
require('swiper');


/*--------------------------------------------------------------------------*
 * ポップアップウィンドウ
 *
 * jquery.openwin.js
 * http://shanabrian.com/web/jquery/window01.php
 *
 * 下記の様にhtml側のrel要素で個別にオプション指定も可。
 * <a href="" class="openwin" rel="scrollbars=yes,target=_self,blur=true">hoge</a>
 *--------------------------------------------------------------------------*/

$(function () {
	$.fn.openwin = function (settings) {
		settings = $.extend({
			option: {
				width: false,
				height: false,
				top: false,
				left: false,
				menubar: 'no',
				toolbar: 'no',
				location: 'no',
				status: 'no',
				resizable: 'no',
				scrollbars: 'no',
				directories: 'no',
				titlebar: 'yes',
				fullscreen: 'no'
			},
			target: '_blank',
			blur: false,
			focus: false
		}, settings);

		$(this).on('click', function () {
			var options = [];
			var target = settings.target;
			var url = $(this).attr('href');

			if ($(this).attr('rel')) {
				var rel = $(this).attr('rel').split(',');
				var relOption = {};
				$.each(settings.option, function (i, rel) {
					var a = rel[i].split('=');
					relOption[a[0]] = a[1];
				});
			}

			$.each(settings.option, function (k) {
				var v = settings.option[k];
				if (relOption) {
					if (relOption[k]) {
						v = relOption[k];
					}
				}
				if (v) {
					options.push(k + '=' + v);
				}
			});
			if (relOption) {
				if (relOption['target']) {
					target = relOption['target'];
				}
			}
			var newWin = window.open(url, target, options.join(','));
			if (settings.blur === true) {
				newWin.blur();
			}
			if (settings.focus === true) {
				newWin.focus();
			}
			return false;
		});
		return this;
	};
});


$(function () {
	// ポップアップウィンドウの設定
	$('a.openwin').openwin({
		option: {
			width: 1000,
			height: 900,
			top: false,
			left: false,
			menubar: "no",
			toolbar: "no",
			location: "no",
			status: "no",
			resizable: "yes",
			scrollbars: "yes",
			directories: "no",
			titlebar: "yes",
			fullscreen: "no"
		}
	});
});




$(function () {

	/*--------------------------------------------------------------------------*
	 * menu
	 *--------------------------------------------------------------------------*/

	var flag = false;
	var $navGlobal = $('.nav-global');
	var headerHeight = $('.header').innerHeight();
	var headerInnerHeight = $('.header__inner').innerHeight();
	var $humberger = $('.header-humberger');
	var windowWidth = $(window).width();
	var $navDropBoxPC = $('.nav-global__element__dropdownPC');
	var $navDropBoxSP = $('.nav-global__element__dropdownSP');
	var navFlag = false;
	var $navMidDropPC = $('.index-section01__element__dropdownPC');
	var $navMidDropSP = $('.index-section01__element__dropdownSP');

	$(window).on('load resize', function () {
		if (windowWidth > 768) {
			var headerHeight = $('.header').innerHeight();
			$('main').css('padding-top', headerHeight + 'px');

		} else {
			var headerHeight = $('.header').innerHeight();
			$('main').css('padding-top', headerHeight + 'px');
		}
	});

	$humberger.on('click', function () {
		if (!flag) {
			$humberger.addClass('active');
			$navGlobal.css('top', headerInnerHeight + 3 + 'px');
			$navGlobal.fadeIn(function () {
				flag = true;
			});
		} else {
			$humberger.removeClass('active');
			$navGlobal.fadeOut(function () {
				flag = false;
			});
		}
	});



	

	// $navMidDrop.hover(function () {
	// 	$(this).children('.index-section01__element__dropdown__inner').show();
	// }, function () {
	// 	$(this).children('.index-section01__element__dropdown__inner').hide();
	// })

	// $navDropBox.on('click', function () {
	// 	if (!navFlag) {
	// 		$(this).children('.dropdown__inner').show();

	// 	} else {
	// 		$(this).children('.dropdown__inner').hide();
			
	// 	}
	// });

	$navDropBoxPC.hover(function () {
		$(this).children('.dropdown__inner').show();
	}, function () {
		$(this).children('.dropdown__inner').hide();
	})
	$navDropBoxSP.on('click',function(){
		$(this).children('.dropdown__inner').slideToggle(2);
	});


	$navMidDropPC.hover(function () {
		$(this).children('.index-section01__element__dropdown__wrapper').show();
	}, function () {
		$(this).children('.index-section01__element__dropdown__wrapper').hide();
	});
	$navMidDropSP.on('click',function(){
		$(this).children('.index-section01__element__dropdown__wrapper').slideToggle(2);
	});
	
	
	
	$('.link_area').on('click',function(){
		location.href = $(this).attr('data-url');
	});



	/*--------------------------------------------------------------------------*
	 * スムーズスクロール
	 *--------------------------------------------------------------------------*/
	$('a[href^="#"]').click(function () {
		var speed = 500;
		var href = $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({
			scrollTop: position
		}, speed, "swing");
		return false;
	});


	/*--------------------------------------------------------------------------*
	 * inview 設定
	 *--------------------------------------------------------------------------*/

	//COMMON

	$('.inviewset').css('opacity', '0');

	$('.inviewset').on('inview', function () {
		$(this).delay(200).animate({
			opacity: '1'
		}, 1000);
	});

	$('.inviewchain01').css('opacity', '0');
	$('.inviewchain02').css('opacity', '0');
	$('.inviewchain03').css('opacity', '0');
	$('.inviewchain04').css('opacity', '0');
	$('.inviewchain05').css('opacity', '0');
	$('.inviewchain06').css('opacity', '0');

	$('.inviewchainwrap').on('inview', function () {
		$(this).find('.inviewchain01').delay(300).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain02').delay(600).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain03').delay(900).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain04').delay(1200).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain05').delay(1500).animate({
			opacity: '1'
		}, 600);
		$(this).find('.inviewchain06').delay(1800).animate({
			opacity: '1'
		}, 600);
	});

	$('.lifestyle-title__head p').on('inview', function () {
		$(this).addClass('lifestyle-title__head-inview');
	});

	//TOP PAGE
	$('.index-upper__block').on('inview', function () {
		$(this).next('.index-upper__bg').stop().delay(400).animate({
			opacity: '1'
		}, 1100);
		if ($(this).parent().hasClass('index-upper__inner01')) {
			$(this).children('.index-upper__title').delay(400).animate({
				color: '#FFF'
			}, 1100);
		}
	});

	$('.index-lower__ornament01').css('left', '-50%').css('opacity', '0');
	$('.index-lower__ornament02').css('right', '-50%').css('opacity', '0');
	$('.index-lower__ornament03').css('left', '-50%').css('opacity', '0');


	$('.index-lower__inner').on('inview', function () {
		$(this).children('.index-lower__ornament01').stop().delay(200).animate({
			left: '',
			opacity: '1'
		}, 1000);
		$(this).children('.index-lower__ornament02').stop().delay(200).animate({
			right: '',
			opacity: '1'
		}, 1000);
		$(this).children('.index-lower__ornament03').stop().delay(200).animate({
			left: '',
			opacity: '1'
		}, 1000);
	});




});


/*--------------------------------------------------------------------------*
 * スクローラー設定
 *--------------------------------------------------------------------------*/
var isMobile = false;
isMobile = $('html').is('.skrollr-mb');
if (!isMobile) {
	window.onload = function () {
		var s = skrollr.init({
			forceHeight: false,
			mobileDeceleration: 0.01,
			mobileCheck: function () {
				return isMobile;
			}
		});
	}
}


/*--------------------------------------------------------------------------*
 * ZERO accordion
 *--------------------------------------------------------------------------*/
$('#acc_01').on('click',function(){
	var acc_btn01 = document.getElementById('acc_btn01');
	acc_btn01.checked = false;
});
$('#acc_02').on('click',function(){
	var acc_btn02 = document.getElementById('acc_btn02');
	acc_btn02.checked = false;
});
$('#acc_03').on('click',function(){
	var acc_btn03 = document.getElementById('acc_btn03');
	acc_btn03.checked = false;
});

